import { render, staticRenderFns } from "./Datum.vue?vue&type=template&id=1c7caf67&scoped=true&"
import script from "./Datum.vue?vue&type=script&lang=ts&"
export * from "./Datum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7caf67",
  null
  
)

export default component.exports